
import includes from 'lodash/includes';
import { isEmail } from 'validator';

/**
  Return true if this is a valid email address

  Note we intend to match the *address* only string 
  e.g., 'j.doe@example.com', we do not match 'John Doe <j.doe@example.com>'. 

*/
export const isBasicValidEmail = (emailStr)=>
  isEmail(emailStr) && !includes(emailStr, ',');

export const isValidEmail = isBasicValidEmail;